import { vars } from '@repo/config';
import type { IUsersListResponse } from '../types/i-users-list-response';
import { createGetFetchOptions } from './helper';

const USERS_LIST_LIMIT = 100_000;

export async function fetchUsersList(cookieHeader: string): Promise<IUsersListResponse | null> {
  const usersUrl = new URL('/api/auth/admin/list-users', vars.url.identityUrl);
  usersUrl.searchParams.set('limit', String(USERS_LIST_LIMIT));
  usersUrl.searchParams.set('offset', '0');
  const response = await fetch(usersUrl.toString(), createGetFetchOptions({ cookieHeader }));

  if (!response.ok) {
    return null;
  }

  return (await response.json()) as IUsersListResponse;
}
